import { NextPage } from 'next';
import { SSRConfig, useTranslation } from 'next-i18next';

import { api } from '@api/index';
import {
  PrivacyPolicyDoc,
  PrivacyPolicyRo,
} from '@api/prismic/static-pages/types';
import { captureError } from '@lib/fetch/errors';
import { AugmentedGetServerSideProps } from '@lib/fetch/types';
import { makeTranslations } from '@lib/localization/i18n';
import { TENANT_CONFIG } from '@lib/tenants/config/constants';
import { PageLayout } from '@templates/common/layout/page-layout/PageLayout';
import { PrivacyPolicy } from '@templates/PrivacyPolicy';

interface Props extends SSRConfig {
  data: PrivacyPolicyDoc['data'] | null;
}

const PrivacyPolicyPage: NextPage<Props> = (props) => {
  const { data } = props;
  const { t } = useTranslation();
  const tabTitle = t('privacyPolicy:tabTitle');

  return (
    <PageLayout tabTitle={tabTitle}>
      <PrivacyPolicy data={data} t={t} />
    </PageLayout>
  );
};

export const getServerSideProps: AugmentedGetServerSideProps<Props> = async (
  ctx
) => {
  const { translations, locale } = await makeTranslations(ctx.locale, [
    'privacyPolicy',
  ]);
  let res: PrivacyPolicyRo;

  try {
    res = await api.prismic.staticPages.getPrivacyPolicyPage(
      TENANT_CONFIG[ctx.req.tenantName],
      locale,
      ctx.previewData?.ref
    );
  } catch (err) {
    captureError(`CMS Error while fetching privacy policy`, err);
  }

  return {
    props: {
      ...translations,
      data: res?.data ?? null,
    },
  };
};

export default PrivacyPolicyPage;
